import { EColors } from "common/styles";
import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  z-index: 12;
  width: 100%;
  padding-top: 84px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:28px;

  @media screen and (min-width: 1000px) {
    display: none;
  }
`;

export const Link = styled.a`
  text-decoration: none;
  position: relative;
  &:after {
    position: absolute;
    display: block;
    content: "";
    width: 0%;
    height: 1px;
    background: ${EColors.accent_300};
    position: absolute;
    bottom: -4px;
    left: 0;
    transition: all 0.2s ease;
  }
  &:hover:after {
    width: 100%;
    background: ${EColors.primary_200};
  }
`;

export const Item = styled.p`
  font-weight: 600;
  font-size: 32px;
  line-height: 140%;
  color: ${EColors.white};
  transition: color 0.5s ease-in-out 0.2s;
  cursor: pointer;
  text-align: center;
  &:hover {
    color: ${EColors.primary_200};
  }
`;
